import React from 'react';
import { Link, Navigate, useLocation } from 'react-router-dom';

const NotFound = () => {
  const location = useLocation();

  return location.pathname === '/' ? (
    <Navigate to="/login" replace={true} />
  ) : (
    <>
      <h1>404 - Page Not Found</h1>
      <div>Pas de ressource disponible sur : {location.pathname}</div>
      <Link to={'/login'}>Retour vers la page d&apos;accueil</Link>
    </>
  );
};

export default NotFound;
